import React from 'react';
import { useLanguage } from './LanguageContext';
import { Home, Sparkles, BedDouble, PackageOpen, Briefcase } from 'lucide-react';
export const Services = () => {
  const {
    t
  } = useLanguage();
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const services = [{
    icon: <Home size={22} data-id="element-211" />,
    title: t('services.c1.title'),
    desc: t('services.c1.desc')
  }, {
    icon: <Sparkles size={22} data-id="element-212" />,
    title: t('services.c2.title'),
    desc: t('services.c2.desc')
  }, {
    icon: <BedDouble size={22} data-id="element-213" />,
    title: t('services.c3.title'),
    desc: t('services.c3.desc')
  }, {
    icon: <PackageOpen size={22} data-id="element-214" />,
    title: t('services.c4.title'),
    desc: t('services.c4.desc')
  }, {
    icon: <Briefcase size={22} data-id="element-215" />,
    title: t('services.c5.title'),
    desc: t('services.c5.desc')
  }];
  const renderCard = (service: (typeof services)[number], index: number) => <div key={index} className="bg-white rounded-[16px] border border-brand-gold/25 border-t-[3px] border-t-brand-gold p-8 shadow-card hover:-translate-y-2 hover:border-brand-gold hover:shadow-card-hover transition-all duration-300 ease-in-out" data-id="element-216">
      <div className="w-[52px] h-[52px] rounded-full bg-brand-navy flex items-center justify-center text-white mb-5" data-id="element-217">
        {service.icon}
      </div>
      <h3 className="font-montserrat font-bold text-xl text-brand-navy mb-3" data-id="element-218">
        {service.title}
      </h3>
      <p className="font-inter text-gray-600 leading-relaxed" data-id="element-219">{service.desc}</p>
    </div>;
  const firstRow = services.slice(0, 3);
  const secondRow = services.slice(3, 5);
  return <section id="services" className="bg-brand-marble py-20 relative overflow-hidden" data-id="element-220">
      {/* Subtle marble veins decoration */}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(circle at 20% 30%, #1B2B5E 0%, transparent 50%), radial-gradient(circle at 80% 70%, #C9A84C 0%, transparent 40%)'
    }} data-id="element-221" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-222">
        <div className="text-center mb-16" data-id="element-223">
          <span className="text-brand-gold font-montserrat font-medium text-[12px] tracking-[4px] uppercase block mb-4" data-id="element-224">
            {t('services.label')}
          </span>
          <h2 className="font-montserrat font-extrabold text-[32px] md:text-[42px] text-brand-navy max-w-2xl mx-auto leading-tight" data-id="element-225">
            {t('services.title')}
          </h2>
          <p className="text-brand-gold font-montserrat font-medium text-[13px] tracking-[3px] uppercase mt-4" data-id="element-226">
            {t('services.sub')}
          </p>
        </div>

        <div className="max-w-6xl mx-auto mb-16" data-id="element-227">
          {/* Row 1 — 3 cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6" data-id="element-228">
            {firstRow.map(renderCard)}
          </div>

          {/* Row 2 — 2 cards centered (each constrained to 1/3 width on lg) */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:flex lg:justify-center gap-6" data-id="element-229">
            {secondRow.map((service, i) => <div key={`r2-${i}`} className="lg:w-[calc(33.333%-16px)]" data-id="element-230">
                {renderCard(service, i + firstRow.length)}
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-231">
          <button onClick={() => scrollTo('contact')} className="bg-brand-navy hover:bg-brand-gold hover:text-brand-navy text-white font-montserrat font-bold px-8 py-4 rounded-[28px] shadow-navy transition-colors inline-block" data-id="element-232">
            {t('services.cta')}
          </button>
        </div>
      </div>
    </section>;
};